import { attribute, clickable, collection } from 'ember-cli-page-object';
import flashMessage from 'core/test-support/pages/components/flash-message';
import ProviderCard from 'vagrant/test-support/pages/components/provider-card';
export default (scope = '[data-test-create-providers]', properties = {}) => ({
  scope,
  cards: collection('[data-test-provider-card]', ProviderCard('')),
  add: clickable('.form-actions .hds-button--color-secondary'),
  submitButton: {
    scope: '.hds-button-set button[type="submit"]',
    isDisabled: attribute('disabled')
  },
  cancelButton: {
    scope: '.hds-button-set a.hds-button--color-secondary'
  },
  flash: {
    ...flashMessage,
    resetScope: true
  },
  ...properties
});